<template>
  <nx-dialog :value="active" @input="close" max-width="400px" :icon="icon || 'error'" :icon-color="iconColor" :title="translatedTitle">
    <div v-html="translatedText"></div>
    <template slot="actions">
      <v-btn color="secondary" flat @click="close">{{ $t('message.common.close') }}</v-btn>
    </template>
  </nx-dialog>
</template>

<script>
import NxDialog from '@/components/dialogs/Dialog';
import { mapState } from 'vuex';
import isArray from 'lodash/isArray';
import isEmpty from 'lodash/isEmpty';
import { translateCandidates } from '@/utils';

export default {
  name: 'nx-app-dialog',
  components: { NxDialog },
  computed: {
    ...mapState('dialog', [
      'active',
      'icon',
      'iconColor',
      'title',
      'text',
      'textMultiple',
      'textVariables',
    ]),
    translatedText() {
      if (isArray(this.textMultiple) && !isEmpty(this.textMultiple)) {
        return this.textMultiple
          .map(text => this.translate(text, this.textVariables))
          .map(text => `<p>${text}</p>`)
          .join('');
      }
      return `<p>${this.translate(this.text, this.textVariables)}</p>`;
    },
    translatedTitle() {
      return this.translate(this.title);
    },
  },
  methods: {
    translate(translatable, translationVars = []) {
      return translateCandidates(
        [
          `message.error.${translatable}`,
          `message.${translatable}`,
          translatable,
        ],
        translatable,
        translationVars,
      );
    },
    close() {
      this.$store.dispatch('dialog/CLOSE');
    },
  },
};
</script>
